import type { ExperimentTypes } from "./experimentType";

export type AtExperimentIdType = "experiment-navigation-items";

export const AtExperimentList: ExperimentTypes<AtExperimentIdType>[] = [
  {
    id: "experiment-navigation-items",
    name: "Experiment Navigation Items",
    description: "This is the experiment navigation items."
  }
];
